module.exports = __webpack_public_path__ + "@/assets/img/discounts-icon.e29d964f.svg";